export const heroSliderData = [
  {
    logo_image: "/ergo_logo.png",
  },
  {
    logo_image: "/GIG_Logo.jpg",
  },
  {
    logo_image: "/qoala_logo.png",
  },
  {
    logo_image: "/tata_aig_logo.jpeg",
  },
  {
    logo_image: "/tvs_logo.jpg",
  },
  {
    logo_image: "/hdfc-logo.jpg",
  },
  {
    logo_image: "/bajaj_logo.jpg",
  },
  {
    logo_image: "/rsgi_logo.jpg",
  },
  {
    logo_image: "/quick_insure_logo.jpg",
  },
  {
    logo_image: "/renew_buy_logo.jpeg",
  },
  {
    logo_image: "/oona_logo.jpg",
  },
  {
    logo_image: "/zurich_logo.png",
  },
];
